module.exports = __webpack_public_path__ + "img/fix1.png";